import React from 'react';
import {makeStyles} from '@material-ui/styles';
import Icon from '@material-ui/core/Icon';
import {BLACK, warningColor, WHITE} from '../../../styles/colors';

const useStyles = makeStyles((theme) => ({
  customIconWrapper: {
    width: 72,
    height: 72,
    marginRight: 4,
    '@media(max-width: 767px)': {
      display: 'none',
    },
  },

  whiteIconElement: {
    fill: WHITE,
  },

  blackIconElement: {
    fill: BLACK,
  },

  wariningIconElement: {
    fill: warningColor,
  },
}));

const CWarningIcon = ({}: Props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Icon className={classes.customIconWrapper}>
        <svg>
          <g id="Warning">
            <circle id="WarningCircle" className={classes.wariningIconElement} cx="36" cy="33" r="14.5" />
            <path
              id="Border_2_"
              className={classes.whiteIconElement}
              d="M36,50.5c-9.6,0-17.5-7.9-17.5-17.5S26.4,15.5,36,15.5S53.5,23.4,53.5,33
		S45.6,50.5,36,50.5z M36,18.5c-8,0-14.5,6.5-14.5,14.5S28,47.5,36,47.5S50.5,41,50.5,33S44,18.5,36,18.5z"
            />
            <path
              id="WarningCustomIcon"
              className={classes.blackIconElement}
              d="M34.5,38.2c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.6-0.4,1.1-0.4c0.5,0,0.8,0.1,1.1,0.4
		c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.8-0.4,1c-0.3,0.3-0.6,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.1-0.4C34.6,38.9,34.5,38.6,34.5,38.2z
		 M34.8,26.4h2.5v6.1l-0.5,3h-1.5l-0.5-3V26.4z"
            />
          </g>
        </svg>
      </Icon>
    </React.Fragment>
  );
};

type Props = {};

export default CWarningIcon;
